<div class="EFShowcase text-light">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true" [isLarge]="true"></app-pg-loading>
    }
    @else {
        @for (resourceId of showcaseResourceIdList; track resourceId; let i = $index) {
            @if (i == previousShowcaseIndex || i == currentShowcaseIndex || i == nextShowcaseIndex) {
                <div class="EFShowcase-Item {{ i == currentShowcaseIndex ? 'EFShowcase-Item--Current pg-animation-fadein' : i == previousShowcaseIndex ? 'EFShowcase-Item--Previous pg-animation-fadeout' : 'EFShowcase-Item--Next' }}">
                    @if(getProductData(showcaseResourceIdList[i]); as item) {
                        @if(item.data; as product) {
                            <div class="EFShowcase-Item-Image">
                                <app-pg-image-autosize [src]="product.flyer || product.cover || product.images[0]" [fit]="product.flyer ? 'contain' : 'cover'"></app-pg-image-autosize>
                            </div>
                            
                            @if(showTextOn(product) || showQROn(product)) {
                                <div class="EFShowcase-Item-Text rounded">
                                    @if (showTextOn(product)) {
                                        <div class="EFShowcase-Item-Text-Main {{ showQR ? 'me-3' : '' }} {{switchLanguage ? 'EFShowcase-Item-Text-Main--SwitchLanguage' : ''}} EFShowcase-Item-Text-Main--QRScale{{ QROptions?.scale }}">
                                            <h3 class="EFShowcase-Item-Text-Main-Title m-0 d-flex">
                                                <div>{{getTranslatedProperty(product, 'title')}}</div>
                                                <div>
                                                    <span class="badge bg-primary ms-2">{{getCurrentLanguage()}}</span>
                                                </div>
                                            </h3>
                                            <div>
                                                @if (formatProductLocation(product); as location) {
                                                    <h5 class="EFShowcase-Item-Text-Main-Subtitle mt-2">
                                                        <i class="fa-regular fa-location-dot me-2 opacity-70"></i><span>{{location}}</span>
                                                    </h5>
                                                }
                                                @if (getTranslatedProperty(product, 'description'); as description) {
                                                    <div class="EFShowcase-Item-Text-Main-Text mt-3" [innerHTML]="description"></div>
                                                }
                                            </div>
                                        </div>
                                    }
                
                                    @if(showQROn(product)) {
                                        <div class="EFShowcase-Item-Text-QR rounded">
                                            <app-pg-qrcode [text]="getProductURL(product)" [options]="QROptions"></app-pg-qrcode>
                                        </div>
                                    }
                                </div>
                            }
                        }
                    }
                    @else {
                        <app-pg-loading [isLarge]="true" [isOverlay]="true"></app-pg-loading>
                    }
                </div>
            }
        }
    }
</div>
